"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var _utils = _interopRequireDefault(require("../../../utils/utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectElement = function SelectElement(_ref) {
  var item = _ref.item;
  console.log("ESTILOS Select field: ", item);
  var defaultStyles = {};
  var style = !item.isActiveCustomStyles ? defaultStyles : _utils.default.stringToObject(item.customStyles);
  console.log("ESTILOS Select style: ", style);
  return /*#__PURE__*/React.createElement(_core.FormControl, {
    style: style
  }, /*#__PURE__*/React.createElement(_core.InputLabel, null, item.attributes.label), /*#__PURE__*/React.createElement(_core.Select, {
    name: item.name,
    value: item.attributes.value,
    disabled: item.isChild.parentId || !item.isChild.parentId ? true : false
  }, /*#__PURE__*/React.createElement(_core.MenuItem, {
    value: "",
    disabled: true
  }, item.attributes.placeholder), item.source.defaultValues.map(function (t, index) {
    var value = t.value && t.value.value ? t.value.value : t.value ? t.value : "";
    var label = t.label && t.label.label ? t.label.label : t.label ? t.label : "";
    return /*#__PURE__*/React.createElement(_core.MenuItem, {
      key: "type_".concat(index),
      value: value
    }, label);
  })), /*#__PURE__*/React.createElement(_core.FormHelperText, null, item.attributes.placeholder));
};

var _default = SelectElement;
exports.default = _default;